import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clay = defineConnector({
  identifier: "clay",
  name: "Clay",
  tagLine: "Data enrichment platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.clay\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "authorization",
        value: app.secret.apiKey,
      },
    ]),
  steps: [
    {
      title: "Find your Clay API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Clay](https://app.clay.com/) and go to **Settings → API** to copy your API key.",
        },
      ],
    },
    {
      title: "Connect your Clay account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Clay instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Workspace ID",
          placeholder: "10608232",
          required: true,
          target: { kind: "configuration", field: "workspaceId" },
          helperText: "The ID of your Clay workspace.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "7de4ba****e439d39****",
          helperText: "The API key for your Clay account.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.clay.com/v3/my-workspaces",
  },
});
